import { finalize } from 'rxjs/operators';

import { MessageConditionType } from './message-condition.model';

export function messageCondition() {
  return {
    restrict: 'E',
    template: require('./message-condition.directive.html'),
    scope: {
      condition: '=',
      dropdownItems: '=',
      readonly: '<',
      exludedTypeCodes: '<?',
      changed: '&',
    },
    controller: controller
  };
}

controller.$inject = ['$scope', 'AngularCustomFieldsService', 'AngularSpinnerService'];
function controller($scope, AngularCustomFieldsService, AngularSpinnerService) {

  $scope.conditionTypeChanged = conditionTypeChanged;
  $scope.formChanged = formChanged;

  $scope.customFieldDropdownItems = [];
  $scope.context = {
    customFields: [],
    customFieldsMap: new Map(),
    description: null,
  };

  init();

  function init() {
    _initCustomFieldsItems();
    $scope.$watch('exludedTypeCodes', newValue => {
      if (newValue) {
        $scope.typeCodes = MessageConditionType.codes().filter(code => !newValue.includes(code));
      } else {
        $scope.typeCodes = MessageConditionType.codes();
      }
    });
  }


  function conditionTypeChanged(conditionTypeCode) {
    $scope.condition.setTypeCode(conditionTypeCode);
    _initCustomFieldsItems();
  }

  function _initCustomFieldsItems() {
    $scope.conditionTypeCode = $scope.condition?.typeCode || null;
    if ($scope.conditionTypeCode === 'custom-field') {
      if (!$scope.context.customFieldsMap.size) {
        AngularSpinnerService.showSpinner();
        AngularCustomFieldsService.getFields()
          .pipe(finalize(() => AngularSpinnerService.hideSpinner()))
          .subscribe({
            next: (response) => {
              $scope.context.customFields = response;
              $scope.context.customFieldsMap = response.reduce((result, customField) => {
                result.set(customField.id, customField);
                return result;
              }, new Map());

              _initDropdownItems();
              _migrateLegacyFormat();
              _updateDescription($scope.condition.parameters);
            }
          });
      } else {
        _updateDescription($scope.condition.parameters);
      }
    }
  }

  function formChanged($event) {
    $scope.condition.parameters = $event;
    _updateDescription($event);
    $scope.changed();
  }

  function _updateDescription(data) {
    $scope.context.description = AngularCustomFieldsService.updateDescription(data, $scope.context.customFieldsMap)
  }

  function _migrateLegacyFormat() {
    const { conditionId, selectedCustomFieldId, value, customFieldItems } = $scope.condition.parameters;
    if (conditionId || selectedCustomFieldId || value)
      $scope.condition.parameters = {
        selectedCustomField: selectedCustomFieldId,
        selectedCondition: conditionId === 1 ? 'equal' : 'not-equal',
        comparedValue: value,
        selectedCustomFieldType: (customFieldItems || []).find(({ id }) => id === selectedCustomFieldId)?.type,
      };
  }

  function _initDropdownItems() {
    $scope.customFieldDropdownItems = $scope.context.customFields
      // The supported types for now.
      .filter(field => field.scope === 'user' &&
        field?.type?.type &&
        ['integer', 'float', 'boolean', 'string', 'email', 'url', 'phone', 'date', 'datetime', 'enum'].includes(field.type.type)
      )
      .map(field => ({
        id: field.id,
        label: `${field.label} (${field.type.type})`,
      }));
  }
} 
